/* ─────────────────────────────────────────────
   Dwira Jewels — Theme JS
   Vanilla JS: header scroll, mobile menu, cart AJAX
   ───────────────────────────────────────────── */

/* ── Utility ── */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

/* ─────────────────────────────────────────────
   HEADER: scroll effect + compact on scroll-down
───────────────────────────────────────────── */
(function initHeader() {
  const header = $('.site-header');
  if (!header) return;

  const compactNavEnabled = header.dataset.compactNav !== 'false';
  if (!compactNavEnabled) {
    header.classList.add('hide-compact-nav');
    document.documentElement.classList.add('compact-no-nav');
  }

  let lastY      = window.scrollY;
  let ticking    = false;
  const COMPACT_THRESHOLD = 80; // px scrolled before compact kicks in
  const RESTORE_DELTA     = 40; // px scrolled back up before restoring

  function update() {
    const y       = window.scrollY;
    const scrolled = y > 24;
    const goingDown = y > lastY;
    const goingUp   = y < lastY - RESTORE_DELTA;

    header.classList.toggle('is-scrolled', scrolled);

    if (goingDown && y > COMPACT_THRESHOLD) {
      if (!header.classList.contains('is-compact')) {
        header.classList.add('is-compact');
        document.documentElement.classList.add('header-compact');
        // compact = no ann bar + 45px inner + subnav (40px if shown on desktop, hidden on mobile)
        const isDesktop = window.innerWidth >= 768;
        const compactH = (compactNavEnabled && isDesktop) ? 85 : 45;
        document.documentElement.style.setProperty('--page-top', compactH + 'px');
      }
    } else if (goingUp || y <= COMPACT_THRESHOLD) {
      if (header.classList.contains('is-compact')) {
        header.classList.remove('is-compact');
        document.documentElement.classList.remove('header-compact');
        document.documentElement.style.removeProperty('--page-top');
      }
    }

    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ─────────────────────────────────────────────
   MEGA MENU
───────────────────────────────────────────── */
(function initMegaMenu() {
  const header     = $('.site-header');
  const menuToggle = $('[data-mega-toggle]');
  const menuLabel  = $('.menu-toggle-label');
  const menuIcon   = $('#menu-icon-open');
  const closeIcon  = $('#menu-icon-close');
  const menu       = $('#mobile-menu');
  const overlay    = $('#mega-overlay');
  const closeBtn   = $('.mega-close-btn');
  const subnav     = $('.header-subnav');
  if (!menu || !menuToggle) return;

  let currentHandle = null;
  let closeTimer = null;

  function activateCollection(handle) {
    if (handle === currentHandle) return;
    currentHandle = handle;

    // Collection links (col 1)
    $$('[data-collection-link]', menu).forEach(el => {
      el.classList.toggle('is-active', el.dataset.collectionLink === handle);
    });

    // Sub-panels (col 2)
    $$('.mega-sub-panel', menu).forEach(el => {
      const active = el.dataset.panel === handle;
      el.classList.toggle('is-active', active);
      if (active) {
        el.classList.add('is-entering');
        setTimeout(() => el.classList.remove('is-entering'), 400);
      }
    });

    // Image panels (col 3) — remove then re-add is-active to retrigger CSS animation
    $$('.mega-image-panel', menu).forEach(el => {
      const active = el.dataset.imagePanel === handle;
      if (active && !el.classList.contains('is-active')) {
        el.classList.add('is-active', 'is-entering');
        setTimeout(() => el.classList.remove('is-entering'), 700);
      } else if (!active) {
        el.classList.remove('is-active', 'is-entering');
      }
    });
  }

  function setOpen(open, handle) {
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    if (overlay) overlay.classList.toggle('is-open', open);
    if (closeBtn) closeBtn.classList.toggle('is-visible', open);
    header.classList.toggle('menu-open', open);
    const isDesktop = window.innerWidth >= 768;
    if (subnav) subnav.classList.toggle('hidden-nav', open && !isDesktop);
    document.body.style.overflow = (open && !isDesktop) ? 'hidden' : '';
    if (menuLabel) menuLabel.textContent = open ? 'Close' : 'Menu';
    if (menuIcon)  menuIcon.style.display  = open ? 'none' : 'block';
    if (closeIcon) closeIcon.style.display = open ? 'block' : 'none';

    // Update subnav active states
    $$('[data-subnav-collection]', subnav).forEach(el => {
      el.classList.toggle('is-active', open && el.dataset.subnavCollection === (handle || currentHandle));
    });

    if (open && handle) activateCollection(handle);
    if (!open) currentHandle = null;
  }

  function scheduleClose() {
    const delay = window.innerWidth >= 768 ? 300 : 200;
    closeTimer = setTimeout(() => setOpen(false), delay);
  }
  function cancelClose() {
    clearTimeout(closeTimer);
  }

  // Hamburger toggle
  menuToggle.addEventListener('click', () => {
    if (menu.classList.contains('is-open')) {
      clearTimeout(closeTimer);
      setOpen(false);
    } else {
      setOpen(true, currentHandle || 'rings');
    }
  });

  // Subnav collection links → open menu with that collection
  $$('[data-subnav-collection]').forEach(link => {
    link.addEventListener('mouseenter', () => {
      cancelClose();
      setOpen(true, link.dataset.subnavCollection);
    });
    link.addEventListener('mouseleave', scheduleClose);
  });

  // Menu area hover keeps it open
  menu.addEventListener('mouseenter', cancelClose);
  menu.addEventListener('mouseleave', scheduleClose);

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('mouseenter', cancelClose);
    closeBtn.addEventListener('click', () => {
      clearTimeout(closeTimer);
      setOpen(false);
    });
  }

  // Overlay click
  if (overlay) overlay.addEventListener('click', () => {
    clearTimeout(closeTimer);
    setOpen(false);
  });

  // Collection link hover/focus in col 1
  $$('[data-collection-link]', menu).forEach(link => {
    link.addEventListener('mouseenter', () => activateCollection(link.dataset.collectionLink));
    link.addEventListener('focus', () => activateCollection(link.dataset.collectionLink));
  });

  // data-mega-close attribute
  $$('[data-mega-close]').forEach(el => {
    if (el === closeBtn) return; // already handled above
    el.addEventListener('click', () => {
      clearTimeout(closeTimer);
      setOpen(false);
    });
  });

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) {
      clearTimeout(closeTimer);
      setOpen(false);
    }
  });
})();

/* ─────────────────────────────────────────────
   SHOPIFY CART API HELPERS (shared)
───────────────────────────────────────────── */
async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function addToCart(variantId, quantity, properties) {
  quantity = quantity || 1;
  properties = properties || {};
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity, properties }),
  });
  return res.json();
}

async function cartUpdate(updates) {
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates }),
  });
  return res.json();
}

async function cartRemove(key) {
  const updates = {}; updates[key] = 0;
  return cartUpdate(updates);
}

function formatMoney(cents) {
  const amount = (cents / 100).toLocaleString('en-IN', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'INR',
    minimumFractionDigits: 0,
  });
  return amount;
}

/* ─────────────────────────────────────────────
   CART DRAWER
───────────────────────────────────────────── */
(function initCart() {
  const overlay    = $('.cart-overlay');
  const drawer     = $('.cart-drawer');
  const openBtns   = $$('[data-cart-open]');
  const closeBtns  = $$('[data-cart-close]');

  if (!drawer) return;

  function openCart() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(btn => btn.addEventListener('click', openCart));
  closeBtns.forEach(btn => btn.addEventListener('click', closeCart));
  if (overlay) overlay.addEventListener('click', closeCart);

  /* ── local aliases ── */
  const updateCart = cartUpdate;
  const removeItem = cartRemove;

  let _prevCartKeys = new Set();

  function renderCartItems(cart) {
    const itemsWrap = $('.cart-items');
    const emptyEl   = $('.cart-empty');
    const footerEl  = $('.cart-footer');
    const countEl   = $('.cart-count');
    const subtotalEl = $('.cart-subtotal-amount');
    const badgeEl   = $('.cart-badge');

    const totalQty = cart.item_count;

    if (badgeEl) {
      badgeEl.textContent = totalQty;
      badgeEl.classList.toggle('visible', totalQty > 0);
    }

    if (countEl) {
      countEl.textContent = totalQty === 0
        ? 'Awaiting your first rarity.'
        : `${totalQty} piece${totalQty > 1 ? 's' : ''} reserved for you`;
    }

    if (!itemsWrap) return;

    if (cart.items.length === 0) {
      if (emptyEl)   emptyEl.hidden   = false;
      if (itemsWrap) itemsWrap.hidden = true;
      if (footerEl)  footerEl.hidden  = true;
      return;
    }

    if (emptyEl)   emptyEl.hidden   = true;
    if (itemsWrap) itemsWrap.hidden = false;
    if (footerEl)  footerEl.hidden  = false;

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsWrap.innerHTML = cart.items.map(item => {
      const qtyBadge = String(item.quantity).padStart(2, '0');
      const imgSrc   = item.image
        ? item.image.replace(/(\.(jpg|jpeg|png|webp))($|\?)/, '$1?width=200$3')
        : '';
      const options  = (item.options_with_values || [])
        .filter(o => o.value && o.value !== 'Default Title')
        .map(o => `<div class="cart-item-option"><dt>${o.name}</dt><dd>${o.value}</dd></div>`)
        .join('');

      return `
        <li class="cart-item" data-key="${item.key}" data-variant="${item.variant_id}">
          <div class="cart-item-img">
            ${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title}" loading="lazy" />` : ''}
            <span class="cart-item-qty-badge">${qtyBadge}</span>
            <button class="cart-item-remove" data-action="remove" aria-label="Remove ${item.product_title}">
              <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.25" width="13" height="13" aria-hidden="true">
                <polyline points="1 3.5 13 3.5"/>
                <path d="M4.5 3.5V2.5a1 1 0 011-1h3a1 1 0 011 1v1M12 3.5l-.9 8a1 1 0 01-1 .9H3.9a1 1 0 01-1-.9L2 3.5"/>
              </svg>
            </button>
          </div>
          <div class="cart-item-info">
            <div class="cart-item-info-top">
              <div class="cart-item-names">
                <p class="cart-item-title font-display">${item.product_title}</p>
                ${item.variant_title && item.variant_title !== 'Default Title'
                  ? `<p class="cart-item-variant eyebrow">${item.variant_title}</p>` : ''}
              </div>
            </div>
            ${options ? `<dl class="cart-item-options">${options}</dl>` : ''}
            <div class="cart-item-controls">
              <div class="qty-control">
                <button class="qty-btn" data-action="decrease" aria-label="Decrease quantity">
                  <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" width="12" height="12"><line x1="2" y1="6" x2="10" y2="6"/></svg>
                </button>
                <span class="qty-value">${item.quantity}</span>
                <button class="qty-btn" data-action="increase" aria-label="Increase quantity">
                  <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" width="12" height="12"><line x1="6" y1="2" x2="6" y2="10"/><line x1="2" y1="6" x2="10" y2="6"/></svg>
                </button>
              </div>
              <p class="cart-item-price font-display">${formatMoney(item.line_price)}</p>
            </div>
          </div>
        </li>`;
    }).join('');

    // Animate newly added items — wait for drawer slide-in to finish (400ms)
    const newKeys = new Set(cart.items.map(i => i.key));
    const newEls = $$('.cart-item', itemsWrap).filter(el => !_prevCartKeys.has(el.dataset.key));
    newEls.forEach(el => el.classList.add('cart-item-enter'));
    setTimeout(() => {
      newEls.forEach(el => el.classList.add('cart-item-enter-active'));
    }, 420);
    _prevCartKeys = newKeys;

    // Bind qty/remove buttons
    $$('.cart-item', itemsWrap).forEach(item => {
      const key = item.dataset.key;
      const qtyEl = item.querySelector('.qty-value');
      let qty = parseInt(qtyEl.textContent, 10);

      item.querySelector('[data-action="increase"]').addEventListener('click', async () => {
        qty++;
        const updates = {}; updates[key] = qty;
        const cart = await updateCart(updates);
        renderCartItems(cart);
      });

      item.querySelector('[data-action="decrease"]').addEventListener('click', async () => {
        if (qty <= 1) {
          const cart = await removeItem(key);
          renderCartItems(cart);
        } else {
          qty--;
          const updates = {}; updates[key] = qty;
          const cart = await updateCart(updates);
          renderCartItems(cart);
        }
      });

      item.querySelector('[data-action="remove"]').addEventListener('click', async () => {
        const cart = await removeItem(key);
        renderCartItems(cart);
      });
    });
  }

  async function refreshCart() {
    try {
      const cart = await fetchCart();
      renderCartItems(cart);
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  }

  // Initial badge count on page load
  refreshCart();

  /* ── Add to cart buttons on product pages ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    const form = btn.closest('form[data-product-form]');
    if (!form) return;

    const variantSelect = form.querySelector('[name="id"]');
    const variantId = variantSelect ? variantSelect.value : btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent.trim();

    btn.innerHTML = `
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14" style="flex-shrink:0">
        <polyline points="2 8 6 12 14 4"/>
      </svg>
      Added`;

    try {
      await addToCart(variantId, 1);
      await refreshCart();
      openCart();
    } catch (err) {
      console.error('Add to cart failed', err);
    } finally {
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 900);
    }
  });

  /* ── Quantity stepper on product page ── */
  (function initQtyStepper() {
    const decBtn = $('#qty-dec');
    const incBtn = $('#qty-inc');
    const display = $('#qty-display');
    const input   = $('#qty-input');
    if (!decBtn || !incBtn || !display || !input) return;

    let qty = 1;

    decBtn.addEventListener('click', () => {
      if (qty <= 1) return;
      qty--;
      display.textContent = qty;
      input.value = qty;
    });

    incBtn.addEventListener('click', () => {
      qty++;
      display.textContent = qty;
      input.value = qty;
    });
  })();

  /* ── Diamond detail block — swap specs when the variant changes ── */
  const diamondData = (() => {
    const el = document.querySelector('[data-diamond-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  })();

  function updateDiamondDetail(variantId) {
    if (!diamondData) return;
    const root = document.querySelector('[data-diamond-detail]');
    if (!root) return;

    const d = diamondData[variantId];
    if (!d) return;

    const set = (key, value, unit) => {
      const el = root.querySelector(`[data-dd="${key}"]`);
      if (el) el.textContent = unit ? `${value} ${unit}` : value;
    };
    // A row is only meaningful when it has a value — numerics must exceed 0,
    // since the metafields carry "0.0" for pieces without that material.
    const row = (key, show) => {
      const el = root.querySelector(`[data-dd-row="${key}"]`) ||
                 root.querySelector(`[data-dd-cell="${key}"]`);
      if (el) el.hidden = !show;
    };

    set('carat', d.carat);
    set('origin', d.origin === 'Lab-grown' ? 'Lab' : d.origin);
    set('color', d.color);
    set('clarity', d.clarity);
    set('metal', d.metal);
    set('gold', d.gold, 'g');
    set('caratrow', d.carat, 'ct');
    set('stone', d.stone, 'g');
    set('lab', d.lab ? `${d.lab} certified` : '');

    const note = root.querySelector('[data-dd="note"]');
    if (note) {
      note.textContent = d.note || '';
      note.hidden = !d.note;
    }

    root.querySelectorAll('[data-dd-cell]').forEach(c => {
      const k = c.dataset.ddCell;
      const v = k === 'carat' ? d.carat > 0 : !!d[k];
      c.hidden = !v;
    });

    row('metal', !!d.metal);
    row('gold', d.gold > 0);
    row('carat', d.carat > 0);
    row('stone', d.stone > 0);

    updateAssuranceKarat(d.metal);
  }

  /**
   * Reprice the quality cards for the currently selected metal. A tier's price depends on
   * both options, so without this the cards would show stale prices from the metal that was
   * selected at render time — worse than no price at all.
   */
  function updateQualityPrices(form, variants, optionMap) {
    // Both the form's picker and the sticky sheet's — see updateMetalPicker.
    document.querySelectorAll('.option-swatches--quality').forEach(wrap => {
      repriceQualityWrap(wrap, variants, optionMap);
    });
  }

  function repriceQualityWrap(wrap, variants, optionMap) {
    const qPos = Number(wrap.querySelector('input[type="radio"][data-position]')?.dataset.position);
    if (!qPos) return;

    wrap.querySelectorAll('[data-quality-price]').forEach(el => {
      const qValue = el.dataset.qualityPrice;
      // Match on every option except the quality one, which we hold at this card's value.
      const match = variants.find(v =>
        v.options.every((opt, i) => {
          const pos = i + 1;
          if (pos === qPos) return opt === qValue;
          return !optionMap[pos] || optionMap[pos] === opt;
        })
      );
      if (!match) return;
      el.textContent = match.available ? formatMoney(match.price) : 'Sold out';
    });
  }

  /**
   * Two-dimensional metal picker. The karat/colour buttons are proxies over the real,
   * visually-hidden radios: a click resolves the combined value ("18KT Rose"), checks that
   * radio and dispatches a bubbling change, so the variant matcher, readouts, sticky bar and
   * diamond block all update through their existing paths.
   */
  function metalParts(value) {
    const karat = (value || '').split(' ')[0];
    return { karat, colour: (value || '').slice(karat.length).trim() };
  }

  // Scoped to the picker, so it resolves whichever radio flavour that context renders:
  // [data-option-swatch] in the form, [data-popup-swatch] in the sticky sheet.
  function metalRadios(picker) {
    return picker.querySelectorAll('input[type="radio"][data-position]');
  }

  function selectMetal(picker, karat, colour) {
    const pos = picker.dataset.position;
    const target = `${karat} ${colour}`;
    const radio = picker.querySelector(
      `input[type="radio"][data-position="${pos}"][value="${CSS.escape(target)}"]`
    );
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Both pickers are refreshed on every change: the form's and the sticky sheet's. Updating
  // only the first would leave the sheet showing a stale karat/colour after a form change.
  function updateMetalPicker() {
    document.querySelectorAll('[data-metal-picker]').forEach(syncMetalPicker);
  }

  function syncMetalPicker(picker) {
    if (!picker) return;
    const checked = picker.querySelector('input[type="radio"][data-position]:checked');
    if (!checked) return;

    const { karat, colour } = metalParts(checked.value);
    const values = [...metalRadios(picker)].map(r => r.value);

    picker.querySelectorAll('[data-metal-karat]').forEach(b => {
      const on = b.dataset.metalKarat === karat;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    // A colour is only offered if it exists for the selected karat.
    picker.querySelectorAll('[data-metal-colour]').forEach(b => {
      const c = b.dataset.metalColour;
      const on = c === colour;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
      b.disabled = !values.includes(`${karat} ${c}`);
    });

    const kRead = picker.querySelector('[data-metal-read="karat"]');
    if (kRead) kRead.textContent = karat;
    const cRead = picker.querySelector('[data-metal-read="colour"]');
    if (cRead) cRead.textContent = colour;

    updateKaratDeltas(picker, karat, colour);
  }

  /**
   * Show what each karat costs relative to the cheapest, holding colour and quality fixed.
   * Colour never moves price, so surfacing the delta here is what makes "karat is the price
   * decision, colour is the aesthetic one" legible rather than something to infer.
   */
  function updateKaratDeltas(picker, karat, colour) {
    // Always the main form: the sticky sheet renders outside it, so closest() would be null
    // there. The sheet mirrors the form's selection anyway, so the form is the truth for both.
    const form = document.querySelector('form[data-product-form]');
    if (!form) return;
    let variants;
    try { variants = JSON.parse(form.dataset.variants || '[]'); } catch (_) { return; }

    const pos = Number(picker.dataset.position);
    const others = {};
    form.querySelectorAll('[data-option-swatch]:checked').forEach(sw => {
      const p = parseInt(sw.dataset.position, 10);
      if (p !== pos) others[p] = sw.value;
    });

    const priceFor = (k) => {
      const target = `${k} ${colour}`;
      const v = variants.find(v =>
        v.options.every((opt, i) => {
          const p = i + 1;
          if (p === pos) return opt === target;
          return !others[p] || others[p] === opt;
        })
      );
      return v ? v.price : null;
    };

    const buttons = [...picker.querySelectorAll('[data-karat-delta]')];
    const prices = buttons.map(b => priceFor(b.dataset.karatDelta));
    const valid = prices.filter(p => p !== null);
    if (valid.length === 0) return;
    const base = Math.min(...valid);

    buttons.forEach((b, i) => {
      const p = prices[i];
      b.textContent = p === null || p === base ? '' : `+${formatMoney(p - base)}`;
    });
  }

  document.addEventListener('click', (e) => {
    const picker = e.target.closest('[data-metal-picker]');
    if (!picker) return;
    // Generic radio selector: the sticky sheet's picker renders [data-popup-swatch], so
    // querying [data-option-swatch] here would find nothing and silently dead-click it.
    const checked = picker.querySelector('input[type="radio"][data-position]:checked');
    if (!checked) return;
    const cur = metalParts(checked.value);

    const kBtn = e.target.closest('[data-metal-karat]');
    if (kBtn) { selectMetal(picker, kBtn.dataset.metalKarat, cur.colour); return; }

    const cBtn = e.target.closest('[data-metal-colour]');
    if (cBtn && !cBtn.disabled) selectMetal(picker, cur.karat, cBtn.dataset.metalColour);
  });

  // Deltas are computed client-side, so paint them once on load. theme.js is deferred, so
  // the picker is already in the DOM here.
  updateMetalPicker();

  /* ── Grades explainer toggle ── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quality-help-btn');
    if (!btn) return;
    const body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    body.classList.toggle('is-open', !open);
  });

  // Assurance copy may carry a [karat] placeholder — keep it honest as the metal changes.
  function updateAssuranceKarat(metal) {
    const karat = (metal || '').split(' ')[0].toLowerCase();
    document.querySelectorAll('[data-assurance-text]').forEach(el => {
      const tpl = el.dataset.assuranceTpl;
      if (!tpl || tpl.indexOf('[karat]') === -1) return;
      el.textContent = tpl.replace(/\[karat\]/g, karat);
    });
  }

  /* ── Variant selection on product page ── */
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option-swatch]')) return;

    const form = e.target.closest('form[data-product-form]');
    if (!form) return;

    // Update swatch visual + "selected value" label
    const parent = e.target.closest('.option-swatches');
    if (parent) {
      $$('label.option-swatch', parent).forEach(l => {
        l.classList.remove('selected');
        l.style.borderColor = '';
        l.style.background  = '';
        l.style.color       = '';
      });
      const activeLabel = document.querySelector(`label[for="${e.target.id}"]`);
      if (activeLabel) {
        activeLabel.classList.add('selected');
        activeLabel.style.borderColor = 'var(--gold)';
        activeLabel.style.background  = 'rgba(243,204,145,0.1)';
        activeLabel.style.color       = 'var(--gold)';
      }
      // Update the "selected value" readout
      const optionName = e.target.dataset.optionName;
      const readoutId  = 'selected-' + optionName.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      const readout    = document.getElementById(readoutId);
      if (readout) readout.textContent = e.target.value;
    }

    // Build current option selections from all checked radios in the form
    const optionMap = {};
    $$('[data-option-swatch]:checked', form).forEach(sw => {
      optionMap[parseInt(sw.dataset.position, 10)] = sw.value;
    });

    // Find matching variant
    const variants = JSON.parse(form.dataset.variants || '[]');
    const matched = variants.find(v =>
      v.options.every((opt, i) => !optionMap[i + 1] || optionMap[i + 1] === opt)
    );

    updateQualityPrices(form, variants, optionMap);
    updateMetalPicker();

    if (matched) {
      const hiddenInput = form.querySelector('[name="id"]');
      if (hiddenInput) hiddenInput.value = matched.id;

      // Update price display using the already-formatted Liquid value isn't available
      // so we use the Intl formatter with the cents value
      const priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(matched.price);

      updateDiamondDetail(matched.id);

      const addBtn = form.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = !matched.available;
        if (!matched.available) {
          addBtn.innerHTML = 'Sold Out';
        } else {
          addBtn.innerHTML = `
            <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1" width="18" height="18" style="margin-right:0.5rem;flex-shrink:0;">
              <path d="M2 2h2l3.4 12h9.8L19 7H5"/><circle cx="8" cy="15.5" r="1"/><circle cx="13" cy="15.5" r="1"/>
            </svg>
            Add to Selection`;
        }
      }
    }
  });

  /* ── Image gallery thumbnails ── */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.thumb');
    if (!thumb) return;
    const gallery = thumb.closest('.product-gallery');
    if (!gallery) return;

    const main = gallery.querySelector('.product-gallery-main img');
    if (main) {
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
    }

    $$('.thumb', gallery).forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });

})();


/* ─────────────────────────────────────────────
   DESCRIPTION TOGGLE
───────────────────────────────────────────── */
(function initDescriptionToggle() {
  $$('.product-desc-toggle-btn').forEach(btn => {
    const bodyId = btn.getAttribute('aria-controls');
    const body   = bodyId ? document.getElementById(bodyId) : null;
    if (!body) return;

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      body.setAttribute('aria-hidden', String(expanded));
      body.classList.toggle('is-open', !expanded);
    });
  });
})();

/* ─────────────────────────────────────────────
   RECENTLY VIEWED (localStorage)
───────────────────────────────────────────── */
(function initRecentlyViewed() {
  const STORAGE_KEY = 'dwira_recently_viewed';
  const MAX = 10;

  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch { return []; }
  }

  function saveItems(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
    catch {}
  }

  // Track current product
  if (window.__dwiraProduct) {
    const current = window.__dwiraProduct;
    let items = getItems().filter(i => i.handle !== current.handle);
    items.unshift(current);
    if (items.length > MAX) items = items.slice(0, MAX);
    saveItems(items);
  }

  // Render recently viewed on product page (excluding current)
  const container = $('#recently-viewed');
  const grid      = $('#recently-viewed-grid');
  if (!container || !grid) return;

  // Read card display flags from data attributes set by Liquid section settings
  const enableHover  = container.dataset.rvEnableHover   === 'true';
  const showType     = container.dataset.rvShowType      !== 'false';
  const showPrice    = container.dataset.rvShowPrice     !== 'false';
  const showSoldOut  = container.dataset.rvShowSoldOut   !== 'false';
  const showRing     = container.dataset.rvShowInsetRing !== 'false';

  const currentHandle = window.__dwiraProduct ? window.__dwiraProduct.handle : null;
  const items = getItems()
    .filter(i => i.handle !== currentHandle)
    .slice(0, 4);

  if (items.length === 0) return;

  grid.innerHTML = items.map(item => `
    <a href="${item.url}" class="product-card">
      <div class="product-card-img">
        ${item.image ? `<img class="product-card-img-primary" src="${item.image}" alt="${item.title}" loading="lazy" />` : ''}
        ${enableHover && item.image2 ? `<img class="product-card-img-hover" src="${item.image2}" alt="${item.title}" loading="lazy" aria-hidden="true" />` : ''}
        ${showSoldOut && item.available === false ? `<span class="product-card-badge eyebrow">Sold out</span>` : ''}
        ${showRing ? `<div class="product-card-inset-ring" aria-hidden="true"></div>` : ''}
      </div>
      <div class="product-card-body">
        ${showType && item.type ? `<p class="product-card-type eyebrow text-muted">${item.type}</p>` : ''}
        <p class="product-card-title font-display">${item.title}</p>
        ${showPrice ? `<p class="product-card-price">${item.price}</p>` : ''}
      </div>
    </a>
  `).join('');

  container.removeAttribute('hidden');
})();

/* ─────────────────────────────────────────────
   FADE-UP on scroll (IntersectionObserver)
───────────────────────────────────────────── */
(function initFadeUp() {
  if (!('IntersectionObserver' in window)) {
    $$('.fade-up').forEach(el => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });

  $$('.fade-up').forEach(el => io.observe(el));

  // Fallback: show anything still invisible after layout settles
  setTimeout(() => {
    $$('.fade-up:not(.is-visible)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('is-visible');
      }
    });
  }, 400);
})();

/* ─────────────────────────────────────────────
   SEARCH DRAWER
───────────────────────────────────────────── */
(function initSearch() {
  const overlay    = $('#search-overlay');
  const drawer     = $('#search-drawer');
  const input      = $('#search-input');
  const clearBtn   = $('#search-clear');
  const closeBtn   = $('#search-close');
  const initial    = $('#search-initial');
  const recent     = $('#search-recent');
  const results    = $('#search-results');
  const footer     = $('#search-footer');
  const footerLink = $('#search-all-link');
  const footerTerm = $('#search-footer-term');

  if (!drawer || !input) return;

  const RECENT_KEY  = 'dwira_recent_searches';
  const RECENT_MAX  = 10;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch { return []; }
  }

  function saveRecent(query) {
    const q = query.trim();
    if (!q) return;
    let list = getRecent().filter(s => s.toLowerCase() !== q.toLowerCase());
    list.unshift(q);
    list = list.slice(0, RECENT_MAX);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch {}
    renderRecent();
  }

  function removeRecent(query) {
    const list = getRecent().filter(s => s !== query);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch {}
    renderRecent();
  }

  function clearAllRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch {}
    renderRecent();
  }

  function renderRecent() {
    if (!recent) return;
    const list = getRecent();
    if (!list.length) { recent.hidden = true; return; }
    recent.hidden = false;
    recent.innerHTML = `
      <div class="search-recent-head">
        <p class="eyebrow text-muted search-initial-label">Recent searches</p>
        <button class="search-recent-clear-all eyebrow" type="button">Clear all</button>
      </div>
      <div class="search-tags">
        ${list.map(q => `
          <div class="search-tag search-tag--recent">
            <button class="search-recent-term" data-recent-term type="button">${q}</button>
            <button class="search-recent-remove" data-recent-remove="${q.replace(/"/g, '&quot;')}" type="button" aria-label="Remove ${q}">
              <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5" width="8" height="8" aria-hidden="true">
                <line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/>
              </svg>
            </button>
          </div>
        `).join('')}
      </div>`;

    recent.querySelector('.search-recent-clear-all').addEventListener('click', clearAllRecent);
    recent.querySelectorAll('[data-recent-term]').forEach(btn => {
      btn.addEventListener('click', () => {
        const q = btn.textContent.trim();
        input.value = q;
        if (clearBtn) clearBtn.hidden = false;
        showLoading();
        fetchSuggestions(q);
      });
    });
    recent.querySelectorAll('[data-recent-remove]').forEach(btn => {
      btn.addEventListener('click', () => removeRecent(btn.dataset.recentRemove));
    });
  }

  let abortController = null;
  let debounceTimer = null;

  function openSearch() {
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderRecent();
    setTimeout(() => input.focus(), 50);
  }

  function closeSearch() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function showInitial() {
    if (recent)  renderRecent();
    if (initial) initial.hidden = false;
    if (results) results.hidden = true;
    if (footer)  footer.hidden  = true;
    if (clearBtn) clearBtn.hidden = true;
  }

  function showLoading() {
    if (recent)  recent.hidden  = true;
    if (initial) initial.hidden = true;
    if (results) results.hidden = false;
    if (clearBtn) clearBtn.hidden = false;

    const cols = window.innerWidth >= 640 ? 4 : 2;
    const skeletons = Array.from({ length: cols }, () => `
      <div class="search-skeleton-item">
        <div class="search-skeleton-img"></div>
        <div class="search-skeleton-title"></div>
        <div class="search-skeleton-price"></div>
      </div>
    `).join('');
    results.innerHTML = `<p class="search-results-heading eyebrow text-muted">Products</p><div class="search-skeleton-grid">${skeletons}</div>`;
  }

  function renderResults(data, query) {
    const products    = (data.resources && data.resources.results && data.resources.results.products)    || [];
    const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    const pages       = (data.resources && data.resources.results && data.resources.results.pages)       || [];

    let html = '';

    if (products.length > 0) {
      html += `<p class="search-results-heading eyebrow text-muted">Products</p>`;
      html += `<div class="search-results-products">`;
      html += products.slice(0, 8).map(p => {
        const imgSrc = p.featured_image?.url || p.featured_image || '';
        const imgUrl = imgSrc ? imgSrc.replace(/(\.(jpg|jpeg|png|webp|gif))($|\?)/, '$1?width=300$3') : '';
        return `
        <a href="${p.url}" class="search-result-card">
          <div class="search-result-img">
            ${imgUrl ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy" />` : ''}
          </div>
          <p class="search-result-title font-display">${p.title}</p>
          <p class="search-result-price">${p.price ? (parseInt(p.price, 10) / 100).toLocaleString('en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR', minimumFractionDigits: 0 }) : ''}</p>
        </a>
      `;
      }).join('');
      html += `</div>`;
    }

    if (collections.length > 0) {
      html += `<p class="search-results-heading eyebrow text-muted">Collections</p>`;
      html += `<div class="search-results-other">`;
      html += collections.map(c => `<a href="${c.url}">${c.title}</a>`).join('');
      html += `</div>`;
    }

    if (pages.length > 0) {
      html += `<p class="search-results-heading eyebrow text-muted">Pages</p>`;
      html += `<div class="search-results-other">`;
      html += pages.map(p => `<a href="${p.url}">${p.title}</a>`).join('');
      html += `</div>`;
    }

    if (!html) {
      html = `<p class="eyebrow text-muted" style="padding:1rem 0;">No results for "${query}"</p>`;
    }

    if (results) results.innerHTML = html;

    if (footer && footerLink && footerTerm) {
      footer.hidden = false;
      footerTerm.textContent = query;
      footerLink.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    }
  }

  async function fetchSuggestions(query) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=8&resources[limit_scope]=each`;
      const res = await fetch(url, { signal: abortController.signal });
      const data = await res.json();
      renderResults(data, query);
    } catch (err) {
      if (err.name !== 'AbortError') console.error('Search failed', err);
    }
  }

  // Save search term on form submit (Enter key or submit button)
  const searchForm = drawer.querySelector('form.search-input-row');
  if (searchForm) {
    searchForm.addEventListener('submit', () => {
      const q = input.value.trim();
      if (q) saveRecent(q);
    });
  }

  // Open buttons
  $$('[data-search-open]').forEach(btn => btn.addEventListener('click', openSearch));

  // Close
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (overlay)  overlay.addEventListener('click', closeSearch);

  // Clear
  if (clearBtn) clearBtn.addEventListener('click', () => {
    input.value = '';
    clearBtn.hidden = true;
    showInitial();
    input.focus();
  });

  // Popular tag pills
  $$('[data-search-tag]').forEach(tag => {
    tag.addEventListener('click', () => {
      const q = tag.textContent.trim();
      input.value = q;
      if (clearBtn) clearBtn.hidden = false;
      showLoading();
      fetchSuggestions(q);
    });
  });

  // Input handler with debounce
  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearBtn.hidden = !q;
    clearTimeout(debounceTimer);
    if (!q) { showInitial(); return; }
    debounceTimer = setTimeout(() => {
      showLoading();
      fetchSuggestions(q);
    }, 280);
  });

  // Keyboard: arrow key navigation through result links
  drawer.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); return; }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const links = $$('a, button:not(#search-clear):not(#search-close)', drawer);
    const focusable = links.filter(el => !el.hidden);
    const idx = focusable.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      focusable[Math.min(idx + 1, focusable.length - 1)]?.focus();
    } else {
      e.preventDefault();
      if (idx <= 0) input.focus();
      else focusable[idx - 1]?.focus();
    }
  });

  showInitial();
})();

/* ─────────────────────────────────────────────
   COLLECTION / SEARCH FILTERS
───────────────────────────────────────────── */
(function initCollectionFilters() {

  // Filter group accordion
  $$('.filter-group').forEach(group => {
    const btn  = group.querySelector('[data-filter-toggle]');
    const body = group.querySelector('.filter-group-body');
    if (!btn || !body) return;

    btn.addEventListener('click', () => {
      const open = group.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  // Show-more for filter values
  $$('[data-filter-show-more]').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.filter-group');
      if (!group) return;
      $$('.filter-list-item.is-hidden-overflow', group).forEach(el => el.classList.remove('is-hidden-overflow'));
      btn.remove();
    });
  });

  // Auto-submit filter form on checkbox change
  $$('[data-filter-form]').forEach(form => {
    $$('input[type="checkbox"]', form).forEach(cb => {
      cb.addEventListener('change', () => form.submit());
    });
  });

  // Sort select redirect (preserve q + type for search page)
  $$('[data-sort-select]').forEach(sel => {
    sel.addEventListener('change', () => {
      const form = sel.closest('form') || sel.closest('[data-filter-form]');
      let q    = null;
      let type = null;

      if (form) {
        const qInput    = form.querySelector('[name="q"]');
        const typeInput = form.querySelector('[name="type"]');
        if (qInput)    q    = qInput.value;
        if (typeInput) type = typeInput.value;
      }

      // Also check sibling hidden inputs near the sort select
      const sortWrap = sel.closest('.filter-sort-wrap');
      if (sortWrap) {
        const qHidden    = sortWrap.querySelector('[data-search-q]');
        const typeHidden = sortWrap.querySelector('[data-search-type]');
        if (qHidden && !q)    q    = qHidden.value;
        if (typeHidden && !type) type = typeHidden.value;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      if (q)    url.searchParams.set('q', q);
      if (type) url.searchParams.set('type', type);
      window.location.href = url.toString();
    });
  });

  // Price range slider
  $$('[data-price-range]').forEach(wrap => {
    const minInput  = wrap.querySelector('[data-price-min]');
    const maxInput  = wrap.querySelector('[data-price-max]');
    const minLabel  = wrap.querySelector('[data-price-min-label]');
    const maxLabel  = wrap.querySelector('[data-price-max-label]');
    const fill      = wrap.querySelector('.price-range-fill');
    if (!minInput || !maxInput) return;

    const rangeMax = parseFloat(wrap.dataset.rangeMax) || 100000;

    function formatPrice(cents) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'INR',
        minimumFractionDigits: 0,
      }).format(cents / 100);
    }

    function updateFill() {
      const min = parseFloat(minInput.value);
      const max = parseFloat(maxInput.value);
      const pMin = (min / rangeMax) * 100;
      const pMax = (max / rangeMax) * 100;
      if (fill) {
        fill.style.left  = pMin + '%';
        fill.style.width = (pMax - pMin) + '%';
      }
      if (minLabel) minLabel.textContent = formatPrice(min);
      if (maxLabel) maxLabel.textContent = formatPrice(max);
    }

    minInput.addEventListener('input', () => {
      if (parseFloat(minInput.value) > parseFloat(maxInput.value)) {
        minInput.value = maxInput.value;
      }
      updateFill();
    });
    maxInput.addEventListener('input', () => {
      if (parseFloat(maxInput.value) < parseFloat(minInput.value)) {
        maxInput.value = minInput.value;
      }
      updateFill();
    });

    // Submit form on mouse-up
    [minInput, maxInput].forEach(el => {
      el.addEventListener('change', () => {
        const form = el.closest('form[data-filter-form]');
        if (form) form.submit();
      });
    });

    updateFill();
  });

  // Custom sort dropdown
  const sortDropdown = $('[data-sort-dropdown]');
  if (sortDropdown) {
    const toggle = sortDropdown.querySelector('[data-sort-toggle]');
    toggle.addEventListener('click', e => {
      e.stopPropagation();
      const open = sortDropdown.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    sortDropdown.querySelectorAll('[data-sort-value]').forEach(opt => {
      opt.addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', opt.dataset.sortValue);
        window.location.href = url.toString();
      });
    });
    document.addEventListener('click', e => {
      if (!sortDropdown.contains(e.target)) {
        sortDropdown.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Collection toolbar: add is-stuck when pinned to header
  const toolbar = $('.collection-toolbar');
  if (toolbar) {
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;height:1px;width:1px;pointer-events:none;';
    toolbar.parentElement.insertBefore(sentinel, toolbar);
    // Resolve --page-top to actual pixels by measuring the site header height
    const siteHeader = $('.site-header');
    const pageTopPx = siteHeader ? Math.round(siteHeader.getBoundingClientRect().bottom) : 108;
    new IntersectionObserver(([e]) => {
      toolbar.classList.toggle('is-stuck', !e.isIntersecting);
    }, { rootMargin: '-' + pageTopPx + 'px 0px 0px 0px', threshold: 0 }).observe(sentinel);
  }

  // Filter sidebar / drawer toggle
  $$('[data-filter-drawer-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const drawer = $('#collection-sidebar') || $('#filter-drawer');
      if (!drawer) return;
      const open = drawer.classList.toggle('is-open');
      drawer.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
      $$('[data-filter-drawer-toggle]').forEach(b => b.setAttribute('aria-expanded', String(open)));
    });
  });

})();

/* ─────────────────────────────────────────────
   SEARCH PAGE — predictive inline results
───────────────────────────────────────────── */
(function initSearchPage() {
  const inputs = $$('.search-page-input');
  if (!inputs.length) return;

  // Insert results panel before the product grid
  let resultsPanel = $('#search-page-results');
  if (!resultsPanel) {
    resultsPanel = document.createElement('div');
    resultsPanel.id = 'search-page-results';
    resultsPanel.className = 'search-page-results container';
    resultsPanel.hidden = true;
    const body = $('.search-page .collection-body');
    if (body) body.parentElement.insertBefore(resultsPanel, body);
  }

  let abort = null;
  let timer = null;

  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'INR',
      minimumFractionDigits: 0
    });
  }

  function renderPageResults(data, query) {
    const products = data.resources?.results?.products || [];
    if (!products.length) {
      resultsPanel.innerHTML = `<p class="eyebrow text-muted" style="padding:2rem 0">No results for &ldquo;${query}&rdquo;</p>`;
      resultsPanel.hidden = false;
      return;
    }
    let html = `<p class="eyebrow text-muted search-results-heading" style="padding-bottom:1rem">Suggestions for &ldquo;${query}&rdquo;</p>`;
    html += `<div class="search-page-predictive-grid">`;
    html += products.slice(0, 6).map(p => {
      const imgSrc = p.featured_image?.url || p.featured_image || '';
      const imgUrl = imgSrc ? imgSrc.replace(/(\.(jpg|jpeg|png|webp|gif))($|\?)/, '$1?width=400$3') : '';
      const soldOut = p.available === false;
      return `
        <a href="${p.url}" class="product-card">
          <div class="product-card-img">
            ${imgUrl ? `<img class="product-card-img-primary" src="${imgUrl}" alt="${p.title}" loading="lazy" />` : ''}
            ${soldOut ? `<span class="product-card-badge eyebrow">Sold out</span>` : ''}
            <div class="product-card-inset-ring" aria-hidden="true"></div>
          </div>
          <div class="product-card-body">
            ${p.product_type ? `<p class="product-card-type eyebrow text-muted">${p.product_type}</p>` : ''}
            <p class="product-card-title font-display">${p.title}</p>
            <p class="product-card-price">${p.price ? formatPrice(p.price) : ''}</p>
          </div>
        </a>`;
    }).join('');
    html += `</div>`;
    html += `<div style="padding:1rem 0;border-top:1px solid var(--border);margin-top:1.5rem;">
      <a href="/search?q=${encodeURIComponent(query)}&type=product" class="collection-page-btn eyebrow">
        See all results for &ldquo;${query}&rdquo;
        <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" width="10" height="10"><polyline points="4 2 8 6 4 10"/></svg>
      </a>
    </div>`;
    resultsPanel.innerHTML = html;
    resultsPanel.hidden = false;
  }

  async function fetchPageSuggestions(query) {
    if (abort) abort.abort();
    abort = new AbortController();
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
      const res = await fetch(url, { signal: abort.signal });
      const data = await res.json();
      renderPageResults(data, query);
    } catch (err) {
      if (err.name !== 'AbortError') console.error('Search page suggest failed', err);
    }
  }

  inputs.forEach(input => {
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (!q) { resultsPanel.hidden = true; return; }
      // keep both inputs (mobile + desktop) in sync
      inputs.forEach(el => { if (el !== input) el.value = input.value; });
      timer = setTimeout(() => fetchPageSuggestions(q), 280);
    });
  });
})();


/* ─────────────────────────────────────────────
   CART PAGE — inline qty editing
───────────────────────────────────────────── */
(function initCartPage() {
  if (!$('[data-cart-page-qty]')) return;

  function getRow(el) {
    return el.closest('.cart-page-item');
  }

  function setLoading(control, loading) {
    $$('.qty-btn', control).forEach(btn => { btn.disabled = loading; });
    control.style.opacity = loading ? '0.5' : '';
  }

  function updateTotals(cart) {
    // Update the subtotal / estimated total displays
    const subtotalEls = $$('.cart-page-summary-line dd:not(.eyebrow), .cart-page-summary-total-amount');
    const lineZero = subtotalEls[0];
    const totalEl  = subtotalEls[subtotalEls.length - 1];
    if (lineZero) lineZero.textContent = formatMoney(cart.total_price);
    if (totalEl)  totalEl.textContent  = formatMoney(cart.total_price);

    // Update cart badge count in header
    const badge = $('.cart-badge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('visible', cart.item_count > 0);
    }
  }

  async function setQty(key, qty, control, row) {
    setLoading(control, true);
    try {
      let cart;
      if (qty <= 0) {
        cart = await cartRemove(key);
        if (row) {
          row.style.transition = 'opacity 0.3s, transform 0.3s';
          row.style.opacity = '0';
          row.style.transform = 'translateX(-1rem)';
          setTimeout(() => row.remove(), 320);
        }
      } else {
        const updates = {}; updates[key] = qty;
        cart = await cartUpdate(updates);
        // Update qty display and badge
        const qtyEl = control.querySelector('.qty-value');
        if (qtyEl) qtyEl.textContent = qty;
        // Update qty badge on image
        if (row) {
          const badge = row.querySelector('.cart-page-item-qty-badge');
          if (badge) badge.textContent = String(qty).padStart(2, '0');
        }
        // Update line price
        if (row && cart.items) {
          const item = cart.items.find(i => i.key === key);
          if (item) {
            const priceEl = row.querySelector('.cart-page-item-price');
            if (priceEl) priceEl.textContent = formatMoney(item.line_price);
          }
        }
      }
      updateTotals(cart);
    } catch (err) {
      console.error('Cart update failed', err);
      setLoading(control, false);
    } finally {
      setLoading(control, false);
    }
  }

  $$('[data-cart-page-qty]').forEach(control => {
    const key   = control.dataset.key;
    const qtyEl = control.querySelector('.qty-value');
    let qty = parseInt(qtyEl.textContent, 10);

    control.querySelector('[data-action="increase"]').addEventListener('click', () => {
      qty++;
      setQty(key, qty, control, getRow(control));
    });

    control.querySelector('[data-action="decrease"]').addEventListener('click', () => {
      qty--;
      setQty(key, qty, control, getRow(control));
    });
  });
})();

/* ─────────────────────────────────────────────
   STICKY ATC BAR + VARIANT POPUP
───────────────────────────────────────────── */
(function initStickyAtc() {
  const bar        = document.getElementById('sticky-atc');
  const barBtn     = document.getElementById('sticky-atc-btn');
  const barPrice   = document.getElementById('sticky-atc-price');
  const overlay    = document.getElementById('sticky-atc-overlay');
  const popup      = document.getElementById('sticky-atc-popup');
  const closeBtn   = document.getElementById('sticky-atc-close');
  const popupBtn   = document.getElementById('satc-popup-atc-btn');
  const popupPrice = document.getElementById('satc-popup-price');
  const mainForm   = document.querySelector('form[data-product-form]');
  const mainBtn    = mainForm && mainForm.querySelector('[data-add-to-cart]');

  if (!bar || !barBtn || !mainForm || !mainBtn) return;

  /* ─── Show/hide bar when main ATC scrolls in/out of view ─── */
  const io = new IntersectionObserver((entries) => {
    const mainVisible = entries[0].isIntersecting;
    bar.classList.toggle('is-visible', !mainVisible);
    bar.setAttribute('aria-hidden', String(mainVisible));
    if (mainVisible) closePopup();
  }, { threshold: 0 });
  io.observe(mainBtn);

  /* ─── Popup open/close ─── */
  function openPopup() {
    if (!popup || !overlay) return;
    popup.classList.add('is-open');
    overlay.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const firstSwatch = popup.querySelector('[data-popup-swatch]');
    if (firstSwatch) firstSwatch.focus();
  }

  function closePopup() {
    if (!popup || !overlay) return;
    popup.classList.remove('is-open');
    overlay.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  barBtn.addEventListener('click', openPopup);
  if (closeBtn)  closeBtn.addEventListener('click', closePopup);
  if (overlay)   overlay.addEventListener('click', closePopup);

  popup && popup.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePopup();
  });

  /* ─── Helper: update a set of swatch labels ─── */
  function updateSwatchVisuals(container, checkedValue) {
    container.querySelectorAll('label.option-swatch').forEach(l => {
      const input = document.getElementById(l.getAttribute('for'));
      const active = input && input.value === checkedValue;
      l.classList.toggle('selected', active);
      l.style.borderColor = active ? 'var(--gold)' : '';
      l.style.background  = active ? 'rgba(243,204,145,0.1)' : '';
      l.style.color       = active ? 'var(--gold)' : '';
    });
  }

  /* ─── Helper: sync price + availability to a button ─── */
  function syncAvailability(btn) {
    if (!btn) return;
    const available = !mainBtn.disabled;
    btn.disabled = !available;
    btn.innerHTML = available
      ? `<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1" width="18" height="18" style="margin-right:0.5rem;flex-shrink:0;" aria-hidden="true"><path d="M2 2h2l3.4 12h9.8L19 7H5"/><circle cx="8" cy="15.5" r="1"/><circle cx="13" cy="15.5" r="1"/></svg>Add to Selection`
      : 'Sold Out';
  }

  /* ─── Popup swatch change → mirror to main form ─── */
  popup && popup.addEventListener('change', (e) => {
    if (!e.target.matches('[data-popup-swatch]')) return;

    const pos  = e.target.dataset.position;
    const val  = e.target.value;
    const name = e.target.dataset.optionName;

    updateSwatchVisuals(e.target.closest('.option-swatches'), val);

    const readout = document.getElementById('satc-selected-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
    if (readout) readout.textContent = val;

    const mainRadio = mainForm.querySelector(
      `[data-option-swatch][data-position="${pos}"][value="${CSS.escape(val)}"]`
    );
    if (mainRadio && !mainRadio.checked) {
      mainRadio.checked = true;
      mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ─── Main form swatch change → mirror to popup + bar price ─── */
  mainForm.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option-swatch]')) return;

    const pos = e.target.dataset.position;
    const val = e.target.value;

    const popupRadio = popup && popup.querySelector(
      `[data-popup-swatch][data-position="${pos}"][value="${CSS.escape(val)}"]`
    );
    if (popupRadio && !popupRadio.checked) {
      popupRadio.checked = true;
      updateSwatchVisuals(popupRadio.closest('.option-swatches'), val);
      const name = popupRadio.dataset.optionName;
      const readout = document.getElementById('satc-selected-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
      if (readout) readout.textContent = val;
    }

    requestAnimationFrame(() => {
      const priceEl = document.getElementById('product-price');
      if (priceEl) {
        if (barPrice)   barPrice.textContent   = priceEl.textContent;
        if (popupPrice) popupPrice.textContent = priceEl.textContent;
      }
      syncAvailability(popupBtn);
      // Keep bar button label in sync too
      const available = !mainBtn.disabled;
      barBtn.disabled = !available;
    });
  });

  /* ─── Popup ATC button → fire main form submit + close popup ─── */
  popupBtn && popupBtn.addEventListener('click', () => {
    mainBtn.click();
    const originalHTML = popupBtn.innerHTML;
    popupBtn.disabled = true;
    popupBtn.innerHTML = `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="14" height="14" style="flex-shrink:0" aria-hidden="true"><polyline points="2 8 6 12 14 4"/></svg> Added`;
    setTimeout(() => {
      popupBtn.disabled = false;
      popupBtn.innerHTML = originalHTML;
      closePopup();
    }, 900);
  });
})();


/* ── Featured film: honour prefers-reduced-motion ──
   autoplay/muted/loop are set as attributes so the video starts without JS. When the visitor
   asks for reduced motion we pause it and show the poster frame instead — the attribute alone
   cannot express that preference. */
(function initFeaturedFilm() {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const apply = () => {
    document.querySelectorAll('.film-video').forEach((v) => {
      if (reduce.matches) {
        v.autoplay = false;
        v.pause();
      } else if (v.paused) {
        v.play().catch(() => {
          /* Autoplay can still be refused (data saver, low power). The poster remains. */
        });
      }
    });
  };
  apply();
  reduce.addEventListener?.('change', apply);
})();

/* ── Page contents list ──
   Built from the headings the page actually renders, rather than a hand-maintained list. The
   imported content leans on h4 as its section heading (not h2), so all three levels are
   collected and their relative depth inferred from which levels are present — assuming h2 is
   the top level would leave policy pages with an empty list.

   Stays hidden unless the page clears the minimum heading count, so short pages are unaffected
   and there is no layout shift. Also wraps wide tables so they scroll instead of stretching
   the page. */
(function initPageToc() {
  const body = document.querySelector('[data-page-body]');
  if (!body) return;

  // Wide imported tables must scroll inside their own box, not widen the layout.
  body.querySelectorAll('table').forEach((t) => {
    if (t.parentElement?.classList.contains('table-scroll')) return;
    const wrap = document.createElement('div');
    wrap.className = 'table-scroll';
    t.parentNode.insertBefore(wrap, t);
    wrap.appendChild(t);
  });

  const toc = document.querySelector('[data-page-toc]');
  if (!toc) return;

  const headings = [...body.querySelectorAll('h2, h3, h4')].filter(
    (h) => h.textContent.trim().length > 0
  );
  const min = Number(toc.dataset.tocMin) || 4;
  if (headings.length < min) return;

  // Infer depth from the levels actually used: if a page only has h4s, they are its top level.
  const levels = [...new Set(headings.map((h) => Number(h.tagName[1])))].sort();
  const list = toc.querySelector('.page-toc-list');

  headings.forEach((h, i) => {
    if (!h.id) {
      const slug = h.textContent.trim().toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .slice(0, 60);
      h.id = slug ? `${slug}-${i}` : `section-${i}`;
    }
    const li = document.createElement('li');
    li.dataset.depth = String(levels.indexOf(Number(h.tagName[1])));
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  toc.hidden = false;
})();

/* ─────────────────────────────────────────────
   FOOTER "SHIP TO": custom country dropdown
   Mirrors the collection sort dropdown behaviour (open/close, click-outside), but on select it
   writes the iso code into the hidden country_code input and submits the localization form —
   which is how {% form 'localization' %} changes the store's country/currency.
───────────────────────────────────────────── */
(function initFooterCountry() {
  const dropdown = document.querySelector('[data-country-dropdown]');
  if (!dropdown) return;
  const toggle = dropdown.querySelector('[data-country-toggle]');
  const codeInput = document.getElementById('footer-country-code');
  const form = document.getElementById('footer-localization-form');

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = dropdown.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  dropdown.querySelectorAll('[data-country-value]').forEach((opt) => {
    opt.addEventListener('click', () => {
      if (!codeInput || !form) return;
      codeInput.value = opt.dataset.countryValue;
      form.submit();
    });
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
})();

/* ─────────────────────────────────────────────────────
   PROMO MODAL
   - Shows up to max-shows times per session (sessionStorage).
   - "Don't show again" button appears after a configurable
     appearance number and permanently suppresses the modal
     via localStorage (survives tab close / new sessions).
   - ?preview_modal bypasses all suppression for testing.
───────────────────────────────────────────────────── */
(function initPromoModal() {
  const modal        = document.getElementById('promo-modal');
  const overlay      = document.getElementById('promo-modal-overlay');
  const teaser       = document.getElementById('promo-teaser');
  const dontShowBtn  = modal && modal.querySelector('[data-promo-dont-show]');
  if (!modal || !overlay) return;

  const sessionKey    = modal.dataset.sessionKey || 'promo-modal-seen';
  const localKey      = sessionKey + '-permanent';
  const previewMode   = location.search.includes('preview_modal');
  const maxShows      = parseInt(modal.dataset.maxShows || '3', 10);
  const dontShowAfter = parseInt(modal.dataset.dontShowAfter || '2', 10);

  const delays = (modal.dataset.delays || '5,60,180')
    .split(',')
    .map(s => parseInt(s.trim(), 10) * 1000);

  if (!previewMode) {
    const expiry = parseInt(localStorage.getItem(localKey) || '0', 10);
    if (expiry && Date.now() < expiry) return;
    if (expiry) localStorage.removeItem(localKey); // expired — clear it
  }

  const teaserKey = sessionKey + '-teaser';
  let showCount = previewMode ? 0 : parseInt(sessionStorage.getItem(sessionKey) || '0', 10);
  if (!previewMode && showCount >= maxShows) return;

  function showTeaser() {
    if (!teaser) return;
    if (!previewMode) sessionStorage.setItem(teaserKey, '1');
    teaser.hidden = false;
    teaser.removeAttribute('aria-hidden');
    requestAnimationFrame(() => requestAnimationFrame(() => teaser.classList.add('is-visible')));
  }

  function hideTeaser() {
    if (!teaser) return;
    sessionStorage.removeItem(teaserKey);
    teaser.classList.remove('is-visible');
    teaser.setAttribute('aria-hidden', 'true');
    teaser.hidden = true;
  }

  function updateDontShowBtn() {
    if (!dontShowBtn) return;
    dontShowBtn.hidden = (showCount + 1) < dontShowAfter;
  }

  function openModal() {
    hideTeaser();
    modal.showModal();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    updateDontShowBtn();
  }

  function closeModal() {
    modal.close();
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    showCount++;
    if (!previewMode) sessionStorage.setItem(sessionKey, String(showCount));

    if (previewMode || showCount < maxShows) {
      showTeaser();
      const nextDelay = previewMode ? 800 : (delays[showCount] !== undefined ? delays[showCount] : delays[delays.length - 1]);
      setTimeout(openModal, nextDelay);
    }
  }

  function dismissPermanently() {
    modal.close();
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    hideTeaser();
    if (!previewMode) localStorage.setItem(localKey, String(Date.now() + 30 * 24 * 60 * 60 * 1000));
  }

  // Restore teaser on page load if it was active before navigation
  if (!previewMode && sessionStorage.getItem(teaserKey)) {
    showTeaser();
  } else {
    const firstDelay = previewMode ? 0 : (delays[0] !== undefined ? delays[0] : 5000);
    setTimeout(openModal, firstDelay);
  }

  modal.querySelector('[data-promo-close]').addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  modal.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
  if (dontShowBtn) dontShowBtn.addEventListener('click', dismissPermanently);

  if (teaser) {
    const teaserOpen    = teaser.querySelector('[data-promo-teaser-open]');
    const teaserDismiss = teaser.querySelector('[data-promo-teaser-dismiss]');
    if (teaserOpen)    teaserOpen.addEventListener('click', openModal);
    if (teaserDismiss) teaserDismiss.addEventListener('click', dismissPermanently);
  }
})();
